var _circle, _circle2, _path, _circle3, _circle4, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEmptySearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 134,
    viewBox: "0 0 134 134",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 67,
    cy: 67,
    r: 67,
    fill: "#E5E8F0"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 61.7308,
    cy: 60.7308,
    r: 27.7308,
    fill: "white",
    stroke: "#8C9EB2",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M102.171 106.828C103.733 108.391 106.266 108.391 107.828 106.828C109.39 105.266 109.39 102.734 107.828 101.172L102.171 106.828ZM79.0944 83.7515L102.171 106.828L107.828 101.172L84.7513 78.0946L79.0944 83.7515Z",
    fill: "#8C9EB2"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 55.2187,
    cy: 56.4686,
    r: 1.96874,
    fill: "#BACBDB"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 67.688,
    cy: 56.4686,
    r: 1.96874,
    fill: "#BACBDB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0312 64.8763C62.6332 63.6263 60.7418 63.6263 59.3438 64.8763",
    stroke: "#BACBDB",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptySearchIcon);
export default __webpack_public_path__ + "static/media/empty-search-icon.5132c068.svg";
export { ForwardRef as ReactComponent };